export const DEFAULT_AVATAR_NAME = 'avatar-agent-default'
